<template>
  <div class="bto-sb-widget-wrap bto-sb-sport-wrap">
    <div class="bto-sb-widget">
      <div class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big">
        <span
          class="bto-sb-sports-icon"
          :class="selectedSport.class || getSportClass(sportId)"></span>
        <h3>{{ selectedSport.name || getSportName(sportId) }}</h3>
      </div>
    </div>
    <div
      class="bto-sb-widget"
      :class="{
        'bto-sb-widget-category-nav': !isUsLayout,
        'bto-sb-widget-main-nav bto-sb-widget-pills-nav': isUsLayout,
      }">
      <div class="bto-sb-widget-content">
        <component :is="isUsLayout ? 'div' : 'empty-component'" class="bto-sb-main-nav-left">
          <ul>
            <li
              v-for="(sport, index) in filterSportTabs"
              :key="index"
              @click="changeComp(sport.id)"
              :class="getActiveClass(sport.id)">
              <a>
                {{ t(sport.value) }}
                <span
                  v-if="sport.key === 'livenow' && liveMatchesLength > 0"
                  class="bto-sb-badge bto-sb-ml5">
                  {{ liveMatchesLength }}
                </span>
              </a>
            </li>
          </ul>
        </component>
      </div>
    </div>
    <component
      :is="isUsLayout ? 'div' : 'empty-component'"
      class="bto-sb-widget bto-sb-widget-tournaments-us"
      v-if="tabIndex === 1">
      <empty-state
        v-if="!selectedSport.items"
        :message="t('Public.NoEventsAvailable')"
        :icon-class="emptyStateIcon" />
      <tournamets-list
        v-for="(sport, index) in selectedSport.items"
        :key="index"
        :sport="selectedSport"
        :category="sport" />
    </component>
    <live-sport v-if="tabIndex === 2" :isCategory="false" />
    <boosted-odd-widget
      v-show="tabIndex === 3"
      :key="$route.params.sportId"
      :showSportFilter="false"
      :showTeamFlags="showTeamIcon"
      :displaySlider="false"
      :embedded="true"
      @showBoostedOdds="checkIfBoostedHaveOdds" />
    <highlights-widget
      v-if="tabIndex === 4"
      :showTeamIcon="showTeamIcon"
      :searchBySport="selectedSport.id"
      endRecord="20"
      :key="$route.params.sportId" />
  </div>
</template>
<script>
  import TournametsList from './tournaments.vue';
  import LiveSport from './live-sport.vue';
  import { EmptyComponent } from '@bto-widgets/utils/shared';
  import store from '../../../store';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import BoostedOddWidget from '@bto-widgets/boosted-odd/web';
  import { SportTabsService } from './service-tournament-matches-request';
  import { LiveWorker } from "../../../workers";


  export default {
    name: 'SportCategoryList',
    components: {
      TournametsList,
      LiveSport,
      EmptyState,
      EmptyComponent,
      BoostedOddWidget
    },
    data() {
      return {
        tabIndex: 1,
        emptyStateIcon: ICON_CLASS.HIGHLIGHTS,
        isUsLayout: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
        sportId: parseInt(this.$route.params.sportId, 10),
        sportTabs: SportTabsService.getOrderedSportTabs(),
        liveMatches: {},
        showBoostedOdds: false,
        showTeamIcon: APP_SETTINGS.category.showTeamIcon,
      };
    },
    computed: {
      selectedSport() {
        return store.state.SportsModule.sport;
      },
      liveMatchesLength() {
        if (!this.liveMatches[this.$route.params.sportId]) {
          return 0;
        }
        return Object.keys(this.liveMatches[this.$route.params.sportId]).length
      },
      filterSportTabs() {
        return this.sportTabs.filter((t) => {
          if (t.key === 'boosted' && !this.showBoostedOdds) {
            return false
          }
          return true;
        });
      }
    },
    watch: {
      '$route'(to) {
        store.commit('updateSelectedSport', parseInt(to.params.sportId, 10));
      }
    },
    created() {
      LiveWorker.postMessage({ ev: 'liveall', resp: {} });
      LiveWorker.addEventListener('message', this.countLiveMatches);
      store.commit('hideAfterRouteWidgets');
      store.commit('updateSelectedSport', parseInt(this.$route.params.sportId, 10));
      if (this.$route.params.tabIndex != undefined) {
        this.changeComp(2);
      } else {
        this.changeComp(this.defaultTabIndex());
      }
    },
    beforeDestroy() {
      LiveWorker.removeEventListener('message', this.countLiveMatches);
    },
    methods: {
      getActiveClass(idx) {
        if (this.tabIndex !== idx) {
          return '';
        }
        return this.isUsLayout ? 'bto-sb-main-nav-active' : 'bto-sb-category-nav-active';
      },
      changeComp(item) {
        this.tabIndex = item;
      },
      getSportClass(sportId) {
        return store.getters.getSportClass(sportId);
      },
      getSportName(sportId) {
        return store.getters.getSportName(sportId);
      },
      defaultTabIndex() {
        const rawDefaultTab = (APP_SETTINGS.settings.defaultSportTab || '').trim();
        const tab = this.sportTabs.find(tab => {
          return tab.key === rawDefaultTab;
        });
        if (!tab) {
          return this.sportTabs[0].id;
        }
        return tab.id;
      },
      countLiveMatches(msg) {
        if (msg.data.type === 'liveall') {
          this.liveMatches = msg.data.data.lm;
        }
      },
      checkIfBoostedHaveOdds(flag) {
        this.showBoostedOdds = flag;
        if (!flag) {
          this.changeComp(this.defaultTabIndex());
        }
      },
    },
  };
</script>